import { useOwnerGate } from "@/hooks/cockpit/useOwnerGate"
import { useCurrentUserStaff } from "@/hooks/useCurrentUserStaff"

// ---------------------------------------------------------------------------
// useSuperAdminGate — client-side UI visibility gate for super-admin-only
// content (currently /reports). Super admin = the owner (Artem, matched by
// email via useOwnerGate) OR anyone carrying the `super_admin` role in the
// staff_roles registry. useCurrentUserStaff collapses ONLY super_admin to
// 'admin' (manager/coach/office_manager keep their own role), so
// `role === 'admin'` there is exactly "super_admin". Today that's Anto.
// RLS still governs the underlying data; this only controls what renders.
// ---------------------------------------------------------------------------

export function useSuperAdminGate(): { isSuperAdmin: boolean; isOwner: boolean; isLoading: boolean } {
  const { isOwner } = useOwnerGate()
  const { currentUserStaff, isLoading } = useCurrentUserStaff()
  const isSuperAdmin = isOwner || currentUserStaff?.role === "admin"
  return { isSuperAdmin, isOwner, isLoading }
}
